import { axios, handleApiError, setToken } from "./Api";

const LoginApi = {
  /**
   * Login as client
   * @param {string} username
   * @param {string} password
   */
  async login(username, password) {
    return axios
      .post(axios.defaults.baseURL + "/login", {
        username: username,
        password: password,
        type: 1
      })
      .then(response => {
        let token = response.data.token;
        setToken(token);
        return response.data;
      })
      .catch(handleApiError);
  },

  /**
   * Logout client
   */
  async logout() {
    return axios.post(axios.defaults.baseURL + "/logout")
  },

  /**
   * Fetch client user email
   */
  async fetchClientUserEmail() {
    return axios.post(axios.defaults.baseURL + "/client-user/email")
      .then(response => {
        return response.data;
      })
      .catch(handleApiError);
  }
};

export default LoginApi;
